// extracted by mini-css-extract-plugin
export default {"item":"Complete_item__jiPoO","item-wp":"Complete_item-wp__jzk8m"};